function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.692 3.029c-.892 0-1.615.69-1.615 1.542v6.858c0 .852.723 1.542 1.615 1.542h2.872c.892 0 1.615-.69 1.615-1.542v-.686c0-.284.242-.514.539-.514.297 0 .538.23.538.514v.686c0 1.42-1.205 2.571-2.692 2.571H3.692C2.205 14 1 12.849 1 11.429V4.57C1 3.151 2.205 2 3.692 2h2.872c1.487 0 2.692 1.151 2.692 2.571v.686a.527.527 0 01-.538.514.527.527 0 01-.539-.514v-.686c0-.852-.723-1.542-1.615-1.542H3.692zm7.517 1.864c.21-.2.551-.2.761 0l2.872 2.743c.21.201.21.527 0 .728l-2.872 2.742c-.21.201-.55.201-.761 0a.498.498 0 010-.727l1.953-1.865H4.41A.527.527 0 013.872 8c0-.284.24-.514.538-.514h8.752L11.209 5.62a.498.498 0 010-.728z",
  fill: "#2D2D2D"
});
function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Login.svg";
export { SvgLogin as ReactComponent };